<template>
  <layout-basic>
    <v-container>
      <activity-widget
        :total_courses="total_courses"
        :total_in_progress_courses="total_in_progress_courses"
        :total_completed_courses="total_completed_courses"
      ></activity-widget>
    </v-container>
  </layout-basic>
</template>
<script>
import LayoutBasic from "@/layouts/Dashboard";
import ActivityWidget from "@/components/authenticated/dashboard/Activitywidget";
import userAPI from "@/api/user.js";

export default {
  name: "Profile",
  components: {
    LayoutBasic,
    ActivityWidget
  },
  data() {
    return {
      total_courses: 0,
      total_in_progress_courses: 0,
      total_completed_courses: 0,
      params: "",
      id: this.$route.params.id,    
    };
  },
  mounted() {
    this.getProfileSummary();
  },
  methods: {
    getProfileSummary() {
      userAPI.getUser(this.id,this.params).then(response => {
        this.total_completed_courses =
          response.data.data.total_completed_courses;
        this.total_courses = response.data.data.total_courses;
        this.total_in_progress_courses =
          response.data.data.total_in_progress;
      });
    }
  }
};
</script>
